import { useEffect, useState } from 'react';
import { extractDominantColor } from '@//utils/image/extractDominantColor';

interface UseDominantColorOptions {
  fallbackColor?: string;
  enabled?: boolean;
}

const useDominantColor = (imageUrl: string | undefined, options: UseDominantColorOptions = {}) => {
  const { fallbackColor = 'var(--color-fill-tertiary, #f7f7f7)', enabled = true } = options;
  const [dominantColor, setDominantColor] = useState<string>(fallbackColor);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!imageUrl || !enabled) {
      setDominantColor(fallbackColor);
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const extractColor = async () => {
      try {
        setIsLoading(true);
        const color = await extractDominantColor(imageUrl);

        if (isMounted) {
          setDominantColor(color);
          setIsLoading(false);
        }
      } catch (_error) {
        if (isMounted) {
          setDominantColor(fallbackColor);
          setIsLoading(false);
        }
      }
    };

    extractColor();

    return () => {
      isMounted = false;
    };
  }, [imageUrl, fallbackColor, enabled]);

  return { dominantColor, isLoading };
};

export default useDominantColor;
